import { type SearchPagination } from '@/scopes/search/search/infrastructure/api/types';
import { DEFAULT_RESULTS_PER_PAGE } from './constants';

interface Dependencies {
  pagination: SearchPagination;
  totalResults: number | undefined;
  resultsPerPage: number;
}

export function paginationResolver(dependencies: Partial<Dependencies>) {
  const { pagination, totalResults, resultsPerPage = DEFAULT_RESULTS_PER_PAGE } = dependencies as Dependencies;

  const DOTS = '...';
  const currentPage = pagination.offset / pagination.limit + 1;
  const numberOfPages = totalResults ? Math.ceil(totalResults / pagination.limit) : 0;
  const isFirstPage = currentPage === 1;
  const isLastPage = currentPage >= numberOfPages;

  function getPages(): (string | number)[] {
    const pages: (string | number)[] = Array.from({ length: numberOfPages }, (_, idx) => idx + 1);

    if (numberOfPages <= 7) return pages;

    const startPage = currentPage - 2;
    const endPage = currentPage + 1;

    if (currentPage < 5) {
      return [...pages.slice(0, 5), DOTS, numberOfPages];
    }

    if (currentPage > numberOfPages - 4) {
      return [1, DOTS, ...pages.slice(numberOfPages - 5)];
    }

    return [1, DOTS, ...pages.slice(startPage, endPage), DOTS, numberOfPages];
  }

  return {
    isFirstPage,
    isLastPage,
    currentPage,
    numberOfPages,
    resultsPerPage,
    DOTS,
    getPages,
  };
}
